import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelServiceContext, withViewModelService } from 'gw-portals-viewmodel-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { PolicyService, UserService, ContactService } from 'gw-capability-gateway';
import metadata from './AccountContactSearchComponent.metadata.json5';
import messages from './AccountContactSearchComponent.messages';
import styles from './AccountContactSearchComponent.module.scss';
import SearchContactComponent from '../SearchContactComponent/SearchContactComponent';
import ContactComponent from '../Contact/ContactComponent';

function AccountContactSearchComponent(props) {
    const {
        submissionVM,
        onValueChange,
        authHeader,
        accountNumber,
        updateWizardData,
        isPolicyChange,
        updateSubmission
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const translator = useContext(TranslatorContext);
    const [searchPniContact, setSearchPniContact] = useState(false);
    const [addPniContact, setAddPniContact] = useState(false);
    const [newContactVM, setNewContactVM] = useState({});
    const [pniNames, setPniNames] = useState([{}]);
    const [defaultPni, setDefaultPni] = useState({ name: submissionVM.baseData.primaryNamedInsured.displayName.value, code: submissionVM.baseData.primaryNamedInsured.publicID.value });
    const [isEditPniName, setEditPniName] = useState(false);


    useEffect(() => {

        const placeHolder = { name: 'Search contact', id: 'search'};
        const value = submissionVM.baseData.account.accountContacts.value.map(contact => {
            // if (submissionVM.baseData.primaryNamedInsured.publicID.value === contact.publicID) {
            //     return { name: submissionVM.baseData.primaryNamedInsured.displayName.value,
            //             code: submissionVM.baseData.primaryNamedInsured.publicID.value };
            // }
            return { name: contact.displayName, code: contact.publicID };

        });
        value.push(placeHolder);
        setPniNames(value);
        setDefaultPni({name: submissionVM.baseData.primaryNamedInsured.displayName.value , code:submissionVM.baseData.primaryNamedInsured.publicID.value });
    }, []);

    const updateContacts = async (contact) => {
        updatePrimaryNamedInsured(contact.publicID);
        setSearchPniContact(false);
        setAddPniContact(false);
    }

    const onAdditionalInsuredInterestChange = (value, model, props) => {
           if(value === 'search') {
               setSearchPniContact(true);
           } else {
            updatePrimaryNamedInsured(value);
           }

    }

    //~ Update the primary Named insured
   const updatePrimaryNamedInsured = async(value) => {
        const updatePNIPromise = isPolicyChange ? EndorsementService : LoadSaveService;
        const jobID = isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value;
        await updatePNIPromise.updatePrimaryNamedInsured(jobID, value, authHeader)
            .then(response => {
                const pni = response;
                setDefaultPni({ name: pni.displayName, code: pni.publicID });
                setEditPniName(false);
                const newSubmissionVM = viewModelService.clone(submissionVM);
                _.set(newSubmissionVM, 'baseData.primaryNamedInsured.value', response);
                if (isPolicyChange) {
                    updateSubmission(newSubmissionVM);
                } else {
                    updateWizardData(newSubmissionVM);
                }
            });

   };
    const updateNewPrimaryNamesInsuredContact = async(data) => {

        const contact = await ContactService.createAccountContact(submissionVM.baseData.accountNumber.value, data, authHeader);
        const newSubmissionVM = viewModelService.clone(submissionVM);
        newSubmissionVM.baseData.account.accountContacts.value.push(contact);
        _.set(newSubmissionVM, 'baseData.primaryNamedInsured.value', contact);
        updateWizardData(newSubmissionVM);
        const prePniNames =  pniNames;
        prePniNames.push({ name: contact.displayName, id: contact.contactPublicID})
        setPniNames(prePniNames);
        setDefaultPni({ name: contact.displayName, id: contact.contactPublicID});
        setEditPniName(false);
        updatePrimaryNamedInsured(contact.contactPublicID);
    }


    const handlePniSearchCancel = () => {
        setSearchPniContact(false);
        setAddPniContact(false);
        setEditPniName(false);
    };

    const createVM = (model) => {
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.gateway.contact.dto.AccountContactDetailsDTO'
        );

    };

    const handleAddNewClick = () => {
        const contactModel =  {
            subtype: "Person",
            primaryAddress: {
                country: "CA",
                state: "ON",
                isFromPortal: true,
            },
            isFromPortal: true,
            active:true,
            accountContactRoles:[
                {
                    subtype:'NamedInsured'
                }
            ]
        }
        setNewContactVM(createVM(contactModel));
        setSearchPniContact(false);
        setAddPniContact(true);
    }

    const saveContact = () => {
        const data = newContactVM.value
        data.displayName = data.firstName + ' ' + data.lastName;
        updateNewPrimaryNamesInsuredContact(data);
        setSearchPniContact(false);
        setAddPniContact(false);
    }

    const onNewValueChange = (value, path) => {
        var _newContactVM = viewModelService.clone(newContactVM);
        _.set(_newContactVM, path, value)
        setNewContactVM(_newContactVM);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: onValueChange,
            showRequired: true
        },

        readOnlyPrimaryNamedInsured: {
            value: defaultPni.name,
        },
        readOnlyPrimaryNamedInsuredContainer: {
            visible: !isEditPniName
        },
        editAdditionalInsuredInterest : {
            onClick: (e) => { setEditPniName(true) },
        },
        searchContact: {
            visible: searchPniContact,
            authHeader: authHeader,
            accountNumber: accountNumber,
            updateContacts: updateContacts,
            handleAddNew: handleAddNewClick,
            handleCancel: handlePniSearchCancel
        },
        addNewContainer: {
            visible: addPniContact
        },
        addContact: {
            contactVM: newContactVM,
            onValueChange: onNewValueChange
        },
        saveContactBtn: {
            onClick: saveContact,
        },
        cancelContactBtn: {
            onClick: handlePniSearchCancel
        },
        additionalInsured: {
            availableValues: pniNames,
            value: defaultPni,
            onValueChange: onAdditionalInsuredInterestChange,
            visible: isEditPniName
        },
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            searchContactComponent: SearchContactComponent,
            contactComponent: ContactComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

AccountContactSearchComponent.propTypes = {
    availableValues: PropTypes.array
}
export default AccountContactSearchComponent;
